import { Link } from 'react-router-dom';

const STATS = [
  { value: '10+', label: 'лет опыта' },
  { value: '500+', label: 'готовых объектов' },
  { value: '100%', label: 'гарантия на каркас' },
];

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/429292f1-2c2f-4db4-8b1a-3d69a79edf2b_compressed_IMG_0729.webp"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 pt-20 pb-10 text-center">
        <div className="mx-auto" style={{ maxWidth: '800px' }}>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5 animate-fade-in-up text-balance">
            Художественная ковка и&nbsp;металлоконструкции для&nbsp;дома и&nbsp;участка
          </h1>
          <p className="text-base md:text-lg text-background-50/85 max-w-2xl mx-auto mb-8 animate-fade-in-up leading-relaxed" style={{ animationDelay: '0.15s' }}>
            Навесы, беседки, ворота, мангальные зоны и&nbsp;кованые изделия. Изготовление и&nbsp;монтаж под ключ в&nbsp;Приютово, Белебее, Ермекеево, Бижбуляке, Абдулино, Пономарёвке, Матвеевке, Новомихайловке, Бавлах, Бугуруслане, Киргиз-Мияках, Туймазах, Октябрьском, Буздяке, Кандрах, Давлеканово, Раевке, Уфе и&nbsp;Чишмах.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-12 animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
            <a
              href="#cta-form"
              className="whitespace-nowrap w-full sm:w-auto bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-base px-8 py-3.5 rounded-md transition-all duration-300 hover:scale-[1.02] active:scale-[0.98] cursor-pointer"
            >
              Рассчитать стоимость
            </a>
            <a
              href="#products"
              className="whitespace-nowrap w-full sm:w-auto border-2 border-background-50/40 hover:border-background-50/70 text-background-50 font-semibold text-base px-8 py-3.5 rounded-md transition-all duration-300 hover:bg-background-50/10 cursor-pointer text-center"
            >
              Смотреть изделия
            </a>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-4 md:gap-8 max-w-xl mx-auto animate-fade-in-up" style={{ animationDelay: '0.45s' }}>
            {STATS.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400">{stat.value}</div>
                <div className="text-xs md:text-sm text-background-50/60 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <span className="w-6 h-6 flex items-center justify-center text-background-50/50">
          <i className="ri-arrow-down-s-line text-2xl"></i>
        </span>
      </div>
    </section>
  );
}